import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';

export const Card = styled(Stack)(() => ({
  background:'white',
  width:'100%',
  height:'100%',
}));